import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION12: PdfComponent = {
  type: 'section',
  id: 'iars12',
  title: '12. Bribery and Ethics',
  content: [
    {
      type: 'altText',
      id: 'iars12bullets',
      content: [
        'Both parties agree to comply with the ',
        'Bribery Act 2010',
        ' and not offer or accept bribes or inducements.',
      ],
      boldFirst: false,
    },
  ],
};
